import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import useParameter from "../../../../../../clients/taxonomy/useParameter";

const Styled = styled.div`
    display: grid;
    gap: 16px;
    grid-template-columns: 2fr 3fr 1fr;

    span:first-of-type {
        font-family: var(--font-mono), monospace;
        letter-spacing: -.04em;
        text-align: right;
    }
`;

function booleanValueFormatter(value) {
    return value ? "Yes" : "No";
}

function enumerationValueFormatter(value, unit, parameter, t9n) {
    const enumValue = parameter.values.find(
        (enumValue) => enumValue.id === value
    );
    return t9n(enumValue.label);
}

function numericValueFormatter(value, unit) {
    if (value === undefined) return undefined;
    if (typeof value === "number") return [value, unit].filter(Boolean).join(" ");
    if ("min" in value && "max" in value) return [value.min ?? "x", "-", value.max ?? "x", unit].filter(Boolean).join(" ");
}

function textValueFormatter(value, unit) {
    return [value, unit].filter(Boolean).join(" ");
}

function defaultValueFormatter(value, __, parameter) {
    console.error(parameter, value);
    return undefined;
}

export default function PropertyCard(props) {
    const { parameterID, values } = props;

    const { i18n } = useTranslation();

    const parameter = useParameter(parameterID).data?.parameter;

    let valueFormatter: (...args: unknown[]) => string | undefined = defaultValueFormatter;
    if (parameter.values?.length) valueFormatter = enumerationValueFormatter;
    else if (parameter.dataType === "boolean") valueFormatter = booleanValueFormatter;
    else if (parameter.dataType === "number") valueFormatter = numericValueFormatter;
    else if (parameter.dataType === "text") valueFormatter = textValueFormatter;

    return (
        <Styled>
            <span>
                { t9n(parameter.name, i18n.language) }
            </span>
            <span>
                {
                    values.map(
                        (value) => valueFormatter(value.value, value.unit, parameter, (t) => t9n(t, i18n.language))
                    ).filter(Boolean).join(", ")
                }
            </span>
        </Styled>
    );
}
